import React from "react";

const Section5 = ({ url }) => {

const steps = [
  {
    side: "left",
    number: "1",
    title: "Discovery Call (Free)",
    desc: "Before we write a single line of code or send a proposal, we spend 30 minutes understanding your business, your bottleneck, and your goal. This call costs you nothing and commits you to nothing.",
  },
  {
    side: "right",
    number: "2",
    title: "Scope & Technical Strategy",
    desc: "We map out exactly what will be built, the technology decisions behind each choice, a realistic timeline, and a fixed or milestone-based cost structure. You receive a complete picture before you commit a single dollar.",
  },
  {
    side: "left",
    number: "3",
    title: "Iterative Development",
    desc: "Development happens in short, visible cycles. You review progress regularly, not at the end of a long, silent build. This ensures fewer surprises and a final product that matches your expectations.",
  },
  {
    side: "right",
    number: "4",
    title: "Quality Assurance & Testing",
    desc: "Every feature is thoroughly tested before it reaches you. We validate security, performance, edge cases, and user experience to ensure a stable, reliable, and production-ready solution.",
  },
  {
    side: "left",
    number: "5",
    title: "Launch & Handover",
    desc: "We do not disappear after go-live. Your team receives full documentation, training, and a structured handover so you are never dependent on us for managing your own system.",
  },
  {
    side: "right",
    number: "6",
    title: "Ongoing Support & Iteration",
    desc: "Your business evolves, and your software should evolve with it. We provide structured support and continuous improvement cycles post-launch to keep your system aligned with your growth.",
  },
];

  return (
    <section className="home-section-5">
      <div className="container">

        <h2 className="s5-title" data-aos="fade-up">Our Custom Software Development Process</h2>
        <p className="s5-subtitle" data-aos="fade-up" data-aos-delay="100">
          Transparency is not a feature we offer. It is how we operate by default. 
          You will never wonder what is happening with your project, what it is going to cost, 
          or when you will see results.
        </p>

        <div className="s5-timeline">

          {/* center vertical line */}
          <div className="s5-timeline-line" />

          {steps.map((step, idx) => (
            <div
              className={`s5-step s5-step--${step.side}`}
              key={idx}
              data-aos={step.side === "left" ? "fade-right" : "fade-left"}
              data-aos-delay={idx * 100}
            >
              {/* card */}
              <div className="s5-card">
                <h3 className="s5-card-title">{step.title}</h3>
                <p className="s5-card-desc">{step.desc}</p>
              </div>

              {/* number badge */}
              <div className="s5-badge">{step.number}</div>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Section5;